import Vue from 'vue'
import moment from 'moment'
import base from './api'

function string2Date(str) {
    if (!str) {
        return null;
    }
    if (str.getTime) {
        //已经是Date
        return str;
    }
    str = str.replace("T", " ");
    var arr = str.split(' ');
    var date = new Date();
    if (arr.length > 0) {
        var arr1 = arr[0].split('-');
        if (arr1.length == 3) {
            var year = +arr1[0];
            var month = +arr1[1] - 1;
            var day = +arr1[2];
            date = new Date(year, month, day);
        }
    }
    if (arr.length > 1) {
        var arr2 = arr[1].split(":");
        if (arr2.length >= 2) {
            date.setHours(+arr2[0]);
            date.setMinutes(+arr2[1]);
        }
        if (arr2.length == 3) {
            var arr3 = arr2[2].split(".");
            if (arr3.length >= 1) {
                date.setSeconds(+arr3[0]);
            }
            if (arr3.length == 2) {
                date.setMilliseconds(+arr3[1]);
            }
        }
    }
    return date;
}

/**
 * TODO:改造成微信显示时间那样?
 * @param timeString
 * @returns {*}
 */
function getFirendlyTimeString(timeString) {
    if (!timeString)
        return "";

    var nowTime = new Date().getTime();
    var date = timeString;
    if (typeof timeString == "string") {
        date = string2Date(timeString);
    }
    var time = date.getTime();
    let str = "前";
    let diffvalue = nowTime - time;
    if (0 > nowTime - time) {
        str = "后";
    }
    var diff = Math.abs(nowTime - time);
    var m = 60 * 1000;
    var h = m * 60;
    if (diff < m) {
        return "刚刚";
    }
    if (diff > m && diff < h) {
        return Math.floor(diff / m) + "分钟" + str;
    }
    if (diff >= h && diff < 5 * h) {
        return Math.floor(diff / h) + "小时" + str;
    }
    var hour = date.getHours();
    if (hour < 10) {
        hour = "0" + hour;
    }
    var minute = date.getMinutes();
    if (minute < 10) {
        minute = "0" + minute;
    }
    var hm = hour + ":" + minute;
    var nowDate = new Date(nowTime);
    var i = nowDate.getDate();
    var j = date.getDate();
    if (diff >= 5 * h && diff < 72 * h) {
        if (i - j == 0) {
            return "今天" + hm;
        }
        if (i - j == 1) {
            return "昨天" + hm;
        }
        if (i - j == 2) {
            return "前天" + hm;
        }
        if (i - j == -1) {
            return "明天" + hm;
        }
        if (i - j == -2) {
            return "后天" + hm;
        }
    }
    if (diff < 60 * 24 * h) {
        return Math.floor(diff / 24 / h) + '天' + str;
    }
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    return year + "年" + month + "月";
    // return year + "-" + month + "-" + j + " " + hm;
}
function getFirendlyDateString(timeString) {
    if (!timeString)
        return "";
    var nowDate = new Date();
    nowDate.setHours(0);
    nowDate.setMinutes(0);
    nowDate.setSeconds(0);
    nowDate.setMilliseconds(0);
    var date = timeString;
    if (typeof timeString == "string") {
        date = string2Date(timeString);
    }
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    var nowTime = nowDate.getTime();
    var time = date.getTime();
    var diff = Math.abs(nowTime - time);

    var i = nowDate.getDate();
    var j = date.getDate();
    var m = 60 * 1000;
    var h = m * 60;
    if (diff < 72 * h) {
        if (i - j == 0) {
            return "今天";
        }
        if (i - j == 1) {
            return "昨天";
        }
        if (i - j == 2) {
            return "前天";
        }
    }
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    return year + "-" + month + "-" + j;
}

const filters = {
    date(value, format = 'YYYY-MM-DD HH:mm:ss') {
        return moment(value).format(format)
    },
    duration(act){
        if(!act){
            return ''
        }
        if(!act.startTime || !act.endTime){
            return '';
        }
        var date1 = act.startTime;
        var date2 = act.endTime;
        if(typeof date1  == 'string'){
            date1 = new Date(act.startTime.replace(/-/g, "/"));
        }
        if(typeof date2 == 'string'){
            date2 = new Date(act.endTime.replace(/-/g, "/"));
        }

        var life  = date2.getTime() - date1.getTime();
        if (life > 3600000 && life <= 86400000) {
            return parseInt(life / 3600000) + '小时' + parseInt((life % 3600000) / 60000) + '分钟';
        } else if (life > 86400000) {
            return parseInt(life / 86400000) + '天' + parseInt(life % 86400000 / 3600000) + '小时' + parseInt(life % 3600000 / 60000) + '分钟'
        } else if (life <= 3600000) {
            return parseInt(life / 60000) + '分钟'
        }
    },
    compareTime(date1, date2, diff){
        //console.log("compareTime1 "+ date1 + "|" + date2)
        if(!date1 || !date2){
            return true
        }
        diff = (diff || 300) * 1000
        if (typeof date1 == "string") {
            date1 = string2Date(date1);
        }
        if (typeof date2 == "string") {
            date2 = string2Date(date2);
        }
        var date1 = date1.getTime();
        var date2 = date2.getTime();
        //console.log("compareTime2 " + date1 + "|" + date2)
        var result = Math.abs(date1 - date2);
        //console.log("compareTime3 " + result + "|" + diff)
        return result > diff;
    },
    niceTime(value){
        return getFirendlyTimeString(value);
    },
    fixedMoney(number){
        return number.toFixed(2)
    },
    fsUrl(value, thumbnail) {
        if (value && value.startsWith("n:")) {
            thumbnail = thumbnail || 'm';
            var replacement = 'http://fs-$1.360ease.com/$2$3';
            if (thumbnail !== 'o') {
                replacement = 'http://fs-$1.360ease.com/$2_' + thumbnail + '$3';
            }
            return value.replace(/n:([^\/]+)\/([^\.]+)((\.?).*)/, replacement);
        }
        return value;
    },
    fromNow(value){
        if(value){
            var start = new Date(value);
            var dateDiff = start.getTime() + 48*60*60*1000 - (new Date()).getTime();
            if (dateDiff > 3600000 && dateDiff <= 172800000) {
                return parseInt(dateDiff / 3600000) + '小时';
            } else if (dateDiff <= 3600000 && dateDiff >= 60000) {
                return parseInt(dateDiff / 60000) + '分钟';
            }
        }
        return "";
    },
    friendlyTime(timeString){
        if (!timeString)
            return "";
        var nowTime = new Date().getTime();
        var date = base.base.string2Date(timeString);
        var time = date.getTime();
        var diff = Math.abs(nowTime - time);
        var m = 60 * 1000;
        var h = m * 60;
        if (diff < m) {
            return "刚刚";
        }
        if (diff > m && diff < h) {
            return parseInt((diff / m)) + "分钟前";
        }
        if (diff >= h && diff < 5 * h) {
            return parseInt((diff / h)) + "小时前";
        }
        var hour = date.getHours();
        if (hour < 10) {
            hour = "0" + hour;
        }
        var minute = date.getMinutes();
        if (minute < 10) {
            minute = "0" + minute;
        }
        var hm = hour + ":" + minute;
        var nowDate = new Date(nowTime);
        var i = nowDate.getDate();
        var j = date.getDate();
        if (diff >= 5 * h && diff < 72 * h) {
            if (i - j == 0) {
                return "今天" + hm;
            }
            if (i - j == 1) {
                return "昨天" + hm;
            }
            if (i - j == 2) {
                return "前天" + hm;
            }
        }
        var nyear = nowDate.getFullYear();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if (nyear == year) {
            return month + "-" + j + " " + hm;
        }
        return year + "-" + month + "-" + j + " " + hm;
    }
};

for (let p in filters) {
    if (!filters.hasOwnProperty(p)) continue;

    Vue.filter(p, filters[p])
}



// WEBPACK FOOTER //
// ./src/filters.js